import {
    GET_DASHBOARD_BEGIN,
    GET_DASHBOARD_SUCCESS,
    GET_DASHBOARD_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case GET_DASHBOARD_BEGIN:
        return {
          ...state,
          sectionsPending: true,
          sectionsError: false
        }
      case GET_DASHBOARD_SUCCESS:
        return {
          ...state, 
          dashSections: action.data.dashSections,
          refreshDate:action.data.refreshDate,
          sectionsPending: false,
          sectionsError: false,
          sectionsSuccess: true
        }
      case GET_DASHBOARD_FAILURE:
        return {
          ...state,
          sectionsPending: false,
          sectionsError: action.data.sectionsError
        }
      default:
        return state
    }
  }